import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { asyncScheduler, firstValueFrom } from 'rxjs';
import { AppState } from '../../core';
import { Building, Path } from '../../core/models';
import { BuildingService, PathDoc, PathRxdbService} from '../../core/services';
import { TestbedRxdbService } from '../../core/services/testbed-rxdb';
import { FesBaseComponent } from '../../shared/components/fes-base.component';

@Component({
  selector: 'app-rxdb-paths-edit',
  templateUrl: './rxdb-paths-edit.component.html',
  styleUrls: ['./rxdb-paths-edit.component.scss']
})
export class RxdbPathsEditComponent extends FesBaseComponent implements OnInit {

  @Input() set path( path : PathDoc ) {
    if ( path ) {
      this._path = path
      this.tmpPath = {...path.toJSON()}
    }
  }

  rxBuildings : Building[] = []
  _path : PathDoc
  tmpPath : Path

  errorMsg: string;
  bProcessing: boolean;

  get path() { return this._path }

  constructor(appState : AppState,
    protected rxPathService: PathRxdbService,
    protected rxdbService: TestbedRxdbService,
    protected buildingService: BuildingService,
    protected editModal : BsModalRef) {
      super(appState);
    }

  ngOnInit(): void {
    this.loadBuildings();
  }

  onCancel() {
    this.editModal.hide()
  }

  ngOnDestroy() {
  }

  async loadBuildings() {
    this.errorMsg = ""
    this.rxBuildings = []
    try {
      const bldgsRxQuery = this.buildingService.rxCollection.find();
      this.rxBuildings = await bldgsRxQuery.exec();
    } catch ( error ) {
      this.errorMsg = this.buildingService.extractErrorMsg(error)
    }
  }


  async onSave() {
    this.errorMsg = ''
    this.bProcessing = true;
    try {
      if ( this.tmpPath.id ) {
        await this.rxPathService.update(this.tmpPath).toPromise()
      }
      this.editModal.hide()
    } catch ( error ) {
      this.errorMsg = this.rxPathService.extractErrorMsg(error)
      this.rxPathService.publishError(error,this)
    } finally {
      asyncScheduler.schedule( () => this.rxPathService.syncNow() )
      this.bProcessing = false
    }
  }
}
